import React from 'react';
import { BrowserRouter, Link } from 'react-router-dom';
import WorkFilter from './WorkFilter';
import WorkPost from '../Posts/WorkPost';
import getWorkData from '../../PostData/workData';
import Popup from './Popup';
import Preview from './Preview';

const WorkSection = () => {
    const workData = getWorkData.slice(0, 12);

    return (
        workData.length !== 0 && <section className="work" id="work">
            <div className="container">
                <div className="text_center mbBig">
                    <h2 className="headingSecondary">My Latest Work</h2>
                </div>

                <WorkFilter></WorkFilter>
            </div> {/* Container */}

            <div className="work-filter workItems">
                {workData.map(work => <WorkPost workData={work} key={work.id}></WorkPost>)}
            </div> {/* Work Items */}

            <div className="text_center"><BrowserRouter forceRefresh={true}><Link to="/latest-work" className="btn btn-primary">Load More Work</Link></BrowserRouter></div>

            {workData.map(work => <Popup workData={work} key={work.id}></Popup>)}
            {workData.map(work => <Preview workData={work} key={work.id}></Preview>)}
        </section> // Work
    );
};

export default WorkSection;